export class AuthError extends Error {
  status: number | null;
  constructor(message: string, status?: number) {
    super(message);
    this.name = 'AuthError';
    this.status = status || null;
  }
}
